import { ref } from 'vue';

import { defineStore } from 'pinia';

const MAINTENANCE_JSON_PATH = '/maintenance.json';

// Полноэкранный maintenance-режим. Флаг живёт в статическом /maintenance.json
// на S3 и переключается workflow-ом .github/workflows/maintenance-mode.yml
// без пересборки приложения. Опрос едет в одном тике с version-check
// (useVersionCheck.js): каждые 5 минут + при фокусе вкладки.
export const useMaintenanceStore = defineStore('maintenance', () => {
  const isMaintenanceActive = ref(false);

  async function checkMaintenance() {
    try {
      const cacheBuster = Date.now();
      const response = await fetch(`${MAINTENANCE_JSON_PATH}?t=${cacheBuster}`, {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();

      // Строгая проверка типа: CloudFront на отсутствующий файл отвечает
      // 200 с index.html (SPA-fallback) — такой ответ не должен трогать флаг.
      if (typeof data?.enabled === 'boolean') {
        isMaintenanceActive.value = data.enabled;
      }
    } catch (error) {
      // Fail-open: ошибка запроса/парсинга не меняет текущее состояние —
      // сетевой сбой не «моргает» оверлеем и не блокирует сайт.
      console.warn('Maintenance check failed:', error.message);
    }
  }

  return {
    isMaintenanceActive,
    checkMaintenance,
  };
});
